var isMobile = window.innerWidth <= 750 ?1:0; 
var haoroomsId = document.getElementById('product-grid');
var MutationObserver = window.MutationObserver || window.webkitMutationObserver || window.MozMutationObserver;

var recordHeight = 0;
var mutationObserver = new MutationObserver(function (mutations) {
  try{
  let height = window.getComputedStyle(haoroomsId).getPropertyValue('height');
  if (height === recordHeight) {
    return;
  }
  recordHeight = height;
  // 之后更新外部容器等操作
  let collection_name = getCollectionName();
  //localStorage.setItem(collection_name,haoroomsId.innerHTML);
  // localSetCache(collection_name,haoroomsId.innerHTML);
  
  // //监听a点击事件
  // listenerAClickEvent(collection_name);
  }catch(e){
    
  }
})

mutationObserver.observe(haoroomsId, {
  childList: true, // 子节点的变动（新增、删除或者更改）
  attributes: true, // 属性的变动
  characterData: true, // 节点内容或节点文本的变动
  subtree: true // 是否将观察器应用于该节点的所有后代节点
})


// initCollectionPage();
function getCollectionName(){
  return location.href.replace("https://gona.com/collections/","")+"_"+isMobile;
}

function listenerAClickEvent(collection_name){
  $('#product-grid li.grid__item a').click(function(){
        var scTop = $(document).scrollTop(); 
        var search = location.search;
        console.log(collection_name+"_top"+"_"+search);
        sessionStorage(collection_name+"_top"+"_"+search,scTop);
  });
}

function initCollectionPage(){
  // 进入页面
  collection_name = getCollectionName();
  console.log("collection_name:"+collection_name);
  // 检查上一次高度是否大于0
  // scTop = localStorage.getItem(collection_name+"_top");
  // html =   localStorage.getItem(collection_name);

  scTop = localGetCache(collection_name+"_top");
  html = localGetCache(collection_name);
  if(typeof html != "string"){
    html = '';
  }
  if(html){
   html = html.replace("[object Object]","");
  }
  console.log(collection_name);
  if(scTop && html){
    document.getElementById('product-grid').innerHTML = html;
    $("html,body").scrollTop(scTop);
  }
}

function localSetCache(name, data) {
  try{
  let expire = new Date().getTime()
  expire = expire + 60 * 5 * 1000;
  const obj = {
    data,
    expire
  };
  sessionStorage.setItem(name, JSON.stringify(obj));
  }catch(e){
    console.log(e);
  }
}

//读取缓存
function localGetCache(name){
  const storage = sessionStorage.getItem(name);
  const time = new Date().getTime();

  let result = {};
  if (storage) {
    const obj = JSON.parse(storage);
    if (time < obj.expire) {
      result = obj.data;
    } else {
      sessionStorage.removeItem(name);
      result = '';
    }
  }
  return result;
}